const notInMinimalExperiments = function notInMinimalExperiments(experimentId, options) {
  const array = ['TREAT1', 'TREAT2', 'TREAT3'];
  return (array.indexOf(experimentId) <= -1) ? options.fn(this) : '';
};

module.exports = notInMinimalExperiments;
